module.exports = {
    // catalogUrl: null,
    catalogUrl: "/catalogs/catalog.json",
    catalogTitle: "Osuna STAC Browser",
    catalogImage: null,
    allowExternalAccess: true,
    allowedDomains: [
      "127.0.0.1",
      "localhost",
      "stac.obs-nantes.fr",
      "vims.univ-nantes.fr",
    ],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        // "de",
        // "ar",
//      "de-CH",
        // "es",
        // "en",
//      "en-GB",
        "en-US",
        "fr",
//      "fr-CA",
//      "fr-CH",
        // "it",
//      "it-CH",
        // "ro",
        // "ja",
        // "pt",
//      "pt-BR",
        // "id",
        // "pl"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    displayGeoTiffByDefault: false,
    displayPreview: true,
    displayOverview: true,
    buildTileUrlTemplate: null,
    getMapSourceOptions: null,
    pathPrefix: "/",
    historyMode: "hash",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showKeywordsInItemCards: false,
    showKeywordsInCatalogCards: false,
    showThumbnailsAsAssets: false,
    searchResultsPerPage: null,
    itemsPerPage: null,
    collectionsPerPage: null,
    maxEntriesPerPage: 1000,
    defaultThumbnailSize: null,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    socialSharing: [],
    preprocessSTAC: null,
    authConfig: null,
    crs: {},
    footerLinks: [
      { label: "Demo browser with SSYS extension" },
      { label: "Provided by Osuna", url: "https://osuna.univ-nantes.fr" },
  ]
};
